module.exports = __webpack_public_path__ + "static/media/arrowBtnBg.b78860b1.png";